module.exports = __webpack_public_path__ + "static/media/footerLogo.1b50d179.svg";